module.exports = [{
      plugin: require('/Users/s/Code/Client/lauv/lauv-songs/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
